import { useLoaderData } from '@remix-run/react';
/**
 * Get the current locale, and the translations for the current locale.
 * Extra data: all available languages.
 */
const useLosseLanguage = () => {
    var _a, _b;
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const { page, languages } = useLoaderData();
    const translations = [];
    (_a = page.translations) === null || _a === void 0 ? void 0 : _a.forEach((translation) => {
        const language = languages === null || languages === void 0 ? void 0 : languages.find(({ default_locale }) => default_locale === (translation === null || translation === void 0 ? void 0 : translation.locale));
        if (!language || !translation) {
            return;
        }
        translations.push({
            language: language,
            ...translation
        });
    });
    return [translations, ((_b = page.locale) === null || _b === void 0 ? void 0 : _b.locale) || 'nl_NL', languages || []];
};
export default useLosseLanguage;
